export default "__VITE_ASSET__DguPTqBV__"